import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.104 16.574a6.477 6.477 0 0 1-6.469-6.47 6.477 6.477 0 0 1 6.47-6.469 6.477 6.477 0 0 1 6.469 6.47 6.477 6.477 0 0 1-6.47 6.469m11.654 4.028-5.392-5.351a8.105 8.105 0 1 0-1.161 1.151l5.402 5.36a.816.816 0 0 0 1.156-.004.818.818 0 0 0-.005-1.156"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
